import React from 'react';
import { Button, Menu, Text } from '@fragments';
import { IconDeviceDesktop, IconDownload } from '@tabler/icons-react';
import ReelsIcon from '../../../../components/ReelsIcon';
import useScriptActions from '../ScriptActions/hooks/useScriptActions';
import memoStudio from '../../../../utils/memoStudio';
import './styles.scss';

// A run that wrote a script attaches it to its last assistant message (the result):
// message id → revision. Answers and manual edits have no run revision, so no card.
export const scriptsByMessage = (messages, revisions) => {
  const scripts = {};
  revisions.forEach(r => {
    const result = r.run_id && messages.filter(m => m.role === 'assistant' && m.run_id === r.run_id).at(-1);
    if (result) scripts[result.id] = r;
  });
  return scripts;
};

// The script a run generated, attached to the run's message like a file: it opens that
// version in the preview, downloads it or opens it in the teleprompter. Every action
// uses this version, the one the card names, even after newer ones.
function ScriptCard({ studio: s, revision, onOpen, onTeleprompter }) {
  const { t } = s;
  const { download, openTeleprompter } = useScriptActions(s, onTeleprompter, null, revision);
  const version = t('revision', { number: revision.revision_number });
  return <div className="studio-script-card">
    <button type="button" className="studio-script-card__open" onClick={() => onOpen(revision.id)} aria-label={`${t('openScript')}: ${revision.script.title}`}>
      <span className="studio-script-card__icon"><ReelsIcon size={28} /></span>
      <span className="studio-script-card__text">
        <Text.span weight={500} contrast={9}>{revision.script.title}</Text.span>
        <Text.caption contrast={6}>{`${t('reels')} · ${version}`}</Text.caption>
      </span>
    </button>
    <div className="studio-script-card__actions">
      <Menu items={[{ label: 'PDF', onClick: () => download('pdf') }, { label: 'DOCX', onClick: () => download('docx') }]}>
        <Button color="overlay" variant="text" size="small" icon={<IconDownload />} aria-label={`${t('download')} (${version})`} tooltip={t('download')} />
      </Menu>
      <Button color="overlay" variant="text" size="small" icon={<IconDeviceDesktop />} aria-label={`${t('teleprompter')} (${version})`} tooltip={t('teleprompter')} onClick={openTeleprompter} />
    </div>
  </div>;
}

// Every `studio` field the card and its actions (useScriptActions) read.
export default memoStudio(ScriptCard, ['t', 'exportScript', 'savedRevision', 'setError']);
